import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import GenericBadge from 'components/Utils/GenericBadge';
import MiscUtils from 'services/MiscUtils';
import GoogleMapsUtils from 'services/GoogleMapsUtils';
import CPPUtils from 'services/CPPUtils';

import './style.scss';

export const PharmacyBadge = ({ pharmacy, showMap = true, isDefault = false }) => (
  <div className="full-width">
    <GenericBadge
      className="pharmacy-badge badge"
      avatar={showMap && <PharmacyImage pharmacy={pharmacy} />}
      title={pharmacy.name}
      info={<InfoText pharmacy={pharmacy} isDefault={isDefault} />}
    />
  </div>
);

const InfoText = ({ pharmacy, isDefault }) => {
  let address = MiscUtils.getFullAddress(pharmacy.address);
  // Faxes go to `preferred_fax` when set, so the badge shows that number (and
  // flags it) instead of the OCP-listed `fax` — what you see is where it sends.
  const hasPreferredFax = !!pharmacy.preferred_fax;
  const faxNumber = CPPUtils.getPharmacyFax(pharmacy);
  return (
    <span className="info">
      <span className="fax-phone">
        <div className="wrapper">
          <Icon src="phone" width="12px" fontAwesomeStyle="fas" />
          <span>{pharmacy.phone}</span>
        </div>
        <div
          className={`wrapper${hasPreferredFax ? ' preferred-fax' : ''}`}
          title={
            hasPreferredFax
              ? `Preferred fax — overrides the listed fax${
                  pharmacy.fax ? ` (${pharmacy.fax})` : ''
                }`
              : undefined
          }
        >
          <Icon src="fax" width="12px" fontAwesomeStyle="fas" />
          <span>{faxNumber}</span>
        </div>
      </span>
      <span className="address truncate" title={address}>
        <Icon src="location-pin" width="12px" fontAwesomeStyle="fas" />
        {address}
      </span>
      {isDefault && (
        <span className="default-line">
          <Icon src="star" width="12px" fontAwesomeStyle="fas" />
          Default pharmacy
        </span>
      )}
    </span>
  );
};

const PharmacyImage = ({ pharmacy }) => {
  let address = encodeURI(MiscUtils.getFullAddress(pharmacy.address));

  address = address.replace('#', '%23');

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`https://www.google.com/maps/search/?api=1&query=${address}`}
      style={{ overflow: 'hidden' }}
    >
      <img
        width="100% !important"
        className="center-cropped avatar"
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${address}&zoom=10&size=100x100&maptype=roadmap&format=png&visual_refresh=true&key=${GoogleMapsUtils.getAPIKey()}`}
        title={'Location of ' + pharmacy.name}
        alt={'Location of ' + pharmacy.name}
      />
    </a>
  );
};

PharmacyBadge.propTypes = {
  pharmacy: PropTypes.object,
  isDefault: PropTypes.bool,
};

export default PharmacyBadge;
